/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 数値型の入力形式の幅指定
 */
export interface FormPagePropertyItemNumberInputFormatWidth { 
    /**
     * 幅
     */
    value: number;
    /**
     * 幅の単位(px固定だが、指定できるようになるかもしれないので含みを持たせている)
     */
    unit: FormPagePropertyItemNumberInputFormatWidth.UnitEnum;
}
export namespace FormPagePropertyItemNumberInputFormatWidth {
    export type UnitEnum = 'px';
    export const UnitEnum = {
        Pixel: 'px' as UnitEnum
    };
}



